import {Component, OnInit, ViewChild} from '@angular/core';
import {NgxModalDraggableDirective} from '../../../../../directives/draggable.directive';
import {SenderService} from '../../../../../services/sender.service';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-faq-post',
  templateUrl: './faq-post.component.html',
  styleUrls: ['./faq-post.component.scss']
})
export class FaqPostComponent implements OnInit {

  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(
    public senderService: SenderService,
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
  }
}
